import React from "react";

const testimonialsData = [
  {
    avatar: "https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg",
    name: "Martin Escobar",
    country: "United States",
    quote:
      "Pkantree is the best platform to plant trees and save the environment. I have planted over 100 trees and I am proud of it.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/79.jpg",
    name: "Angela Stian",
    country: "United Kingdom",
    quote:
      "I have been using Plantree for over a year now and I am very happy with the service. I have planted over 50 trees and I am proud of it.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/86.jpg",
    name: "Karim Ahmed",
    country: "Egypt",
    quote:
      "Plantree is the best platform to plant trees and save the environment. I have planted over 100 trees and I am proud of it.",
  },
];

const Testimonial = () => {
  return (
    <section className="py-14 bg-gray-900">
      <div className="max-w-screen-xl mx-auto px-4 md:px-8">
        <div className="max-w-xl sm:text-center md:mx-auto">
          <h3 className="text-white text-3xl font-semibold sm:text-4xl">
            Environment saviours around the world
          </h3>
          <p className="mt-3 text-gray-300">
            Here's what some of our customers have to say about our service. We are proud to have helped them plant trees and save the environment. We are committed to making the world a greener place. Join us in our mission to save the planet. Together, we can make a difference. 
          </p>
        </div>
        <div className="mt-12">
          <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {testimonialsData.map((item, idx) => (
              <li key={idx} className="bg-gray-800 p-6 rounded-xl">
                <figure>
                  <div className="flex items-center gap-x-4">
                    <img
                      src={item.avatar}
                      className="w-16 h-16 rounded-full"
                      alt={`${item.name} avatar`}
                    />
                    <div>
                      <span className="block text-white font-semibold">
                        {item.name}
                      </span>
                      <span className="block text-gray-400 text-sm mt-0.5">
                        {item.country}
                      </span>
                    </div>
                  </div>
                  <blockquote>
                    <p className="mt-6 text-gray-300">{item.quote}</p>
                  </blockquote>
                </figure>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
